export class AddPriorHistory {
  static readonly type = '[Contract.Prior_History] Add Prior History';
  constructor(public priorHistory: any) {}
}

export class DeletePriorHistory {
  static readonly type = '[Contract.Prior_History] Delete Prior History';
  constructor(public priorHistoryID: string) {}
}

export class RestorePriorHistory {
  static readonly type = '[Contract.Prior_History] Restore Prior History';
  constructor(public priorHistoryID: string) {}
}

export class UpdatePriorHistory {
  static readonly type = '[Contract.Prior_History] Update Prior History';
  constructor(public priorHistory: any) {}
}

export class AddLossHistory {
  static readonly type = '[Contract.Prior_History] Add Loss History';
  constructor(public lossHistory: any, public priorHistoryID: string) {}
}

export class UpdateLossHistory {
  static readonly type = '[Contract.Prior_History] Update Loss History';
  constructor(public lossHistory: any) {}
}

export class DeleteLossHistory {
  static readonly type = '[Contract.Prior_History] Delete Loss History';
  constructor(public lossHistoryID: string) {}
}

export class RestoreLossHistory {
  static readonly type = '[Contract.Prior_History] Restore Loss History';
  constructor(public lossHistoryID: string) {}
}

export class RecalcPriorHistory {
  static readonly type = '[Contract.Prior_History] Recalc Prior History';
  constructor(public priorHistoryID: string) {}
}

export class RecalcLossHistory {
  static readonly type = '[Contract.Prior_History] Recalc Loss History';
  constructor(public lossHistoryID: string) {}
}
